import { lazy } from "react"
import { useTranslation } from "react-i18next"

import { RegionWrapper } from "@/components/layout/Region"
import { Loader } from "@/components/Loader"

const NewRfqCore = lazy(() => import("./NewRfqCore"))

const LoaderComponent = () => {
  const { t } = useTranslation()
  return (
    <Loader
      ariaLabel={t("credit.loadingNewRFQForm")}
      minWidth="22rem"
      minHeight="22rem"
    />
  )
}

export const NewRfq = () => (
  <RegionWrapper
    className="border-l-6 border-(--bg-primary)"
    fallback={<LoaderComponent />}
  >
    <NewRfqCore>
      <LoaderComponent />
    </NewRfqCore>
  </RegionWrapper>
)

export default NewRfq
